var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.menusEnhanced.length
    ? _c(
        "Collapsible",
        {
          staticClass: "location-box__menues",
          attrs: { "initial-open": false }
        },
        [
          _c("template", { slot: "trigger" }, [
            _c(
              "div",
              { staticClass: "location-box__menues-trigger" },
              [
                _c("SVGMenu", {
                  staticClass: "location-box__menues-trigger-icon"
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "location-box__menues-trigger-text",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("locations.menuTrigger"))
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "location-box__menues-links" },
            _vm._l(_vm.menusEnhanced, function(menu, index) {
              return _c("Button", {
                key: index,
                attrs: {
                  href: menu.url,
                  target: menu.target,
                  text: menu.name,
                  level: "tertiary",
                  arrow: ""
                }
              })
            }),
            1
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }